import React, { useEffect } from 'react';
import API from 'src/api/api';
import { APP_CONSTANT } from 'src/constants';
import LoadingContainer from '../components/LoadingContainer/LoadingContainer';
import { isEmpty } from 'ramda';
import GenericError from 'src/components/GenericError/GenericError';
import { AuthUtil } from 'src/utils';

const withAppPreLoad = (Comp) => (props) => {
  const [hasTenantInfo, setHasTenantInfo] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [errorResponse, setErrorResponse] = React.useState<boolean>(false);

  const tenantNameSlug =
    window.location.hostname === 'localhost'
      ? APP_CONSTANT.SLUG_NAME
      : window.location.hostname.split('.')[0];

  const removeGuestSubmission = (e) => {
    if (e.key === 'role') {
      sessionStorage.removeItem('guestSubmission');
      window.location.reload();
    }
  };

  useEffect(() => {
    window.addEventListener('storage', removeGuestSubmission);

    return () => {
      window.removeEventListener('storage', removeGuestSubmission);
    };
  }, []);

  const fetchUserInfo = async (): Promise<void> => {
    try {
      if (props.cookies.getAll().token) {
        await AuthUtil.fetchCurrentUserInfo(
          props.cookies.getAll().token,
          (user) => {
            const expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + 24 * 3600 * 1000);

            const {
              spouse,
              guardian_1,
              guardian_2,
              billing,
              role,
              primaryInsurance,
              secondaryInsurance,
              ...userInfo
            } = user;

            props.cookies.set('userInfo', JSON.stringify(userInfo), {
              expires: expireDate,
              path: '/'
            });

            props.cookies.set('spouse', JSON.stringify(spouse), {
              expires: expireDate,
              path: '/'
            });

            props.cookies.set(
              'guardian',
              JSON.stringify({
                guardian_1,
                guardian_2
              }),
              {
                expires: expireDate,
                path: '/'
              }
            );

            props.cookies.set('billing', JSON.stringify(billing), {
              expires: expireDate,
              path: '/'
            });

            props.cookies.set(
              'primaryInsurance',
              JSON.stringify(primaryInsurance),
              {
                expires: expireDate,
                path: '/'
              }
            );

            props.cookies.set(
              'secondaryInsurance',
              JSON.stringify(secondaryInsurance),
              {
                expires: expireDate,
                path: '/'
              }
            );

            props.cookies.set('role', role, {
              expires: expireDate,
              path: '/'
            });
          }
        );
      }
    } catch (e) {
      setErrorResponse(true);
    }
  };
 
  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchUserInfo().then((res) => res);
    }, APP_CONSTANT.COOKIE_TIME_INTERVAL);

    (window as any).intervalId1 = intervalId;

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchUserInfo().then((res) => res);
    }, APP_CONSTANT.COOKIE_TIME_INTERVAL);
    (window as any).intervalId2 = intervalId;

    return () => {
      clearInterval(intervalId);
    };
  }, [props.cookies.getAll().token]);

  useEffect(() => {
    if (!props.cookies.getAll().userInfo) return;
  }, [props.cookies.getAll().userInfo]);

  useEffect(() => {
    API()
      .get(`/account/v1/public/tenant/info?nameSlug=${tenantNameSlug}`)
      .then((response) => {
        if (isEmpty(response.data)) {
          setHasTenantInfo(false);
          setIsLoading(false);

          return;
        }

        localStorage.setItem('tenantInfo', JSON.stringify(response.data));
        if (localStorage.getItem('tenantInfo')) {
          setIsLoading(false);
          setHasTenantInfo(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setHasTenantInfo(false);
      });
  }, []);

  return (
    <LoadingContainer isLoading={isLoading}>
      {hasTenantInfo && !errorResponse ? (
        <Comp />
      ) : (
        <GenericError isEnable={true} />
      )}
    </LoadingContainer>
  );
};

export default withAppPreLoad;
